import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const Earnings: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[24px] h-[24]', className)}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 22.7503C8 22.7503 4.75 19.8803 4.75 16.3503V12.6503C4.75 12.2403 5.09 11.9003 5.5 11.9003C5.91 11.9003 6.25 12.2403 6.25 12.6503C6.25 15.2703 8.72 17.2503 12 17.2503C15.28 17.2503 17.75 15.2703 17.75 12.6503C17.75 12.2403 18.09 11.9003 18.5 11.9003C18.91 11.9003 19.25 12.2403 19.25 12.6503V16.3503C19.25 19.8803 16 22.7503 12 22.7503ZM6.25 16.4603C6.32 19.1103 8.87 21.2503 12 21.2503C15.13 21.2503 17.68 19.1103 17.75 16.4603C16.45 17.8703 14.39 18.7503 12 18.7503C9.61 18.7503 7.56 17.8703 6.25 16.4603Z"
      fill="currentColor"
    />
    <path
      d="M12 13.7502C9.24 13.7502 6.75999 12.5102 5.54999 10.5102C5.02999 9.66024 4.75 8.67025 4.75 7.65025C4.75 5.93025 5.52 4.31024 6.91 3.09024C8.27 1.90024 10.08 1.25024 12 1.25024C13.92 1.25024 15.72 1.90025 17.09 3.08025C18.48 4.31025 19.25 5.93025 19.25 7.65025C19.25 8.67025 18.97 9.65024 18.45 10.5102C17.24 12.5102 14.76 13.7502 12 13.7502ZM12 2.75024C10.44 2.75024 8.98001 3.27024 7.89001 4.23024C6.83001 5.15024 6.25 6.37025 6.25 7.65025C6.25 8.40025 6.44999 9.10024 6.82999 9.73024C7.77999 11.2902 9.76 12.2502 12 12.2502C14.24 12.2502 16.22 11.2802 17.17 9.73024C17.56 9.10024 17.75 8.40025 17.75 7.65025C17.75 6.37025 17.17 5.15024 16.1 4.21024C15.01 3.27024 13.56 2.75024 12 2.75024Z"
      fill="currentColor"
    />
    <path
      d="M12 18.7502C7.87 18.7502 4.75 16.1302 4.75 12.6502V7.65025C4.75 4.12025 8 1.25024 12 1.25024C13.92 1.25024 15.72 1.90025 17.09 3.08025C18.48 4.31025 19.25 5.93025 19.25 7.65025V12.6502C19.25 16.1302 16.13 18.7502 12 18.7502ZM12 2.75024C8.83 2.75024 6.25 4.95025 6.25 7.65025V12.6502C6.25 15.2702 8.72 17.2502 12 17.2502C15.28 17.2502 17.75 15.2702 17.75 12.6502V7.65025C17.75 6.37025 17.17 5.15024 16.1 4.21024C15.01 3.27024 13.56 2.75024 12 2.75024Z"
      fill="currentColor"
    />
  </svg>
);

export default Earnings;
